import Vue, { PluginObject } from "vue";

import access from "@/common/access";

// Permissoes do perfil (Administracao > Perfis) nas telas:
// $check(area, metodo HTTP) — usado pelo menu ("GET" = ver);
// $can(area, acao) — acao = "view" | "create" | "edit" | "delete";
// $allowed(acao) — mesma coisa na area da tela atual (e "save");
// acao especifica ("rma.review") vale em qualquer tela.
// O acesso e carregado pelo guard das rotas (access.load) e e reativo.
class PermissionsPlugin implements PluginObject<any> {
    install = (_Vue: typeof Vue) => {
        _Vue.prototype.$check = function(path: string, method: string) {
            return access.can(path, access.actionOfMethod(method));
        };

        _Vue.prototype.$can = function(area: string, action = "view") {
            return access.can(area, action);
        };

        // Acao na area da tela atual (nome da rota -> area do catalogo).
        // "save": criar em registro novo (/:id = "novo"), editar nos demais;
        // em tela sem :id (lista com dialogo), criar ou editar.
        // Tela sem area (inicio) libera tudo; a API confere de novo.
        _Vue.prototype.$allowed = function(action: string, area?: string) {
            if (action.includes(".")) return access.hasCapability(action);
            const route = this.$route || {};
            const target = area || access.areaOfRoute(route.name);
            if (!target) return true;
            if (action === "save") {
                // Tela de lista: o mesmo dialogo cria e edita (a API confere a acao real).
                const id = route.params ? route.params.id : undefined;
                if (id === undefined) return access.can(target, "create") || access.can(target, "edit");
                return access.can(target, ["novo", "nova", "new", "criar"].includes(String(id)) ? "create" : "edit");
            }
            return access.can(target, action);
        };

        _Vue.prototype.$access = access.state;
    };
    [key: string]: any;
}

const plugin = new PermissionsPlugin();
Vue.use(plugin);
